// extracted by mini-css-extract-plugin
module.exports = {"jsonBody":"jsonBody--kteC8"};